<div class="container-fluid enviroment-state text-center" *ngIf="!environment.production">
    <p class="mb-0">🚀 {{"eess.shared.enviroment.youAre" | translate}} {{"eess.shared.enviroment.test" | translate}} | <span class="capitalize">{{platform}}</span> 🚀</p>
</div>